import type { RefinementCtx } from 'zod';

export const unique =
  <T extends object>(uniqueKeys: { key: keyof T; message: string }[]) =>
  (data: T[], ctx: RefinementCtx) => {
    for (const { key, message } of uniqueKeys) {
      const seen = new Map<string, number[]>();

      // First pass: collect all values and their indices
      for (const [index, item] of data.entries()) {
        const rawValue = item[key];

        // Skip empty strings
        if (typeof rawValue === 'string') {
          const value = rawValue.trim().toLowerCase();
          if (value === '') continue;

          if (!seen.has(value)) {
            seen.set(value, []);
          }
          seen.get(value)!.push(index);
        }
      }

      // Second pass: add issues only for actual duplicates
      for (const [, indices] of seen.entries()) {
        if (indices.length > 1) {
          // Mark all duplicates (including the first occurrence)
          for (const index of indices) {
            ctx.addIssue({
              code: 'custom',
              message,
              path: [index, key.toString()]
            });
          }
        }
      }
    }
  };
